import { Component, ElementRef, ViewChild } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { IndexTyper } from "./index-typer";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { CollectedPreviewItem, GetFeaturedCardsResponse } from "@apiserver-rest/ponder-data-client-base";
import { take } from "rxjs";
import { PreviewItemComponent } from "@ponder-shared/previewItem/preview-item.component";
import { PreviewItemContextMenuComponet } from "@ponder-shared/previewItem/preview-item-context-menu.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AuthSession } from "@ponder-core/auth/auth-session";

@Component({
    imports: [PreviewItemComponent, PreviewItemContextMenuComponet],
    templateUrl: "./index.component.html",
    styleUrl: "./index.style.less"
})
export class IndexComponnet {
    @ViewChild("rewrite") private rewriteRef!: ElementRef<HTMLSpanElement>;

    public featuredCards?: CollectedPreviewItem[];
    private indexTyper!: IndexTyper;

    public isAuthed: boolean = false;

    constructor(private events: EventBroker, private ponderDataClient: PonderDataClient, private auth: AuthService) {
        
    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();

        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession) {
                this.isAuthed = true;
            }
        });

        this.ponderDataClient
            .itemFeatured()
            .pipe(take(1))
            .subscribe({
                next: (response: GetFeaturedCardsResponse) => {
                    this.featuredCards = response.cards;

                    if (this.featuredCards) {
                        this.featuredCards.sort((a, b) => a.item.name!.localeCompare(b.item.name!));
                    }
                }
            });
    }

    public ngAfterViewInit(): void {
        this.indexTyper = new IndexTyper(this.rewriteRef);
        this.indexTyper.start(200);
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }
}